import React, { useEffect, useState, useRef } from 'react'
import moment from 'moment'
import { DatePicker, Button, Select, Input, Tooltip } from 'antd'
import {
  LogoutOutlined,
  DollarCircleOutlined,
  SlidersOutlined,
  RiseOutlined,
} from '@ant-design/icons'
import httpRequest from '../../services/http-request'
import { navigate, Link } from '@reach/router'
import { CSVLink } from 'react-csv'

import LoadingSpinner from '../common/loading-spinner'

const { RangePicker } = DatePicker
const { Option } = Select

const PLReportByMarket = (props) => {
  const [loading, setLoading] = useState(false)
  const [userName, setUserName] = useState('')

  useEffect(() => {
    const userRole = localStorage.getItem('role')
    const loggedUserName = localStorage.getItem('userName')
    if (!userRole || !loggedUserName) {
      props.navigate('/login')
    }
    setUserName(loggedUserName)
  }, [])

  /**
   * Date-range filter section
   */
  const dateFormat = 'Do MMM HH:mm:ss, YYYY'

  const now = moment()
  now.seconds(0)
  now.subtract(now.minutes() % 15, 'minutes')

  const [fromDate, setFromDate] = useState(now.clone().subtract(6, 'hours'))
  const [toDate, setToDate] = useState(now)
  const handleDateRangeChange = (value) => {
    console.log(value)
    const [from, to] = value
    setFromDate(from)
    setToDate(to)
  }

  /**
   * Sport filter section
   */
  const sports = [
    {
      id: -1,
      name: 'All',
    },
    {
      id: 1,
      name: 'Football',
    },
    {
      id: 2,
      name: 'Tennis',
    },
    {
      id: 4,
      name: 'Cricket',
    },
    {
      id: 7,
      name: 'Horse racing',
    },
    {
      id: 4339,
      name: 'Grey Hound racing',
    },
  ]
  const defaultSport = 2
  const [sportId, setSportId] = useState(defaultSport)
  const handleSportChange = (value) => {
    console.log('sport: ', value)
    setSportId(value)
  }

  /**
   * Market type filter section
   */
  const marketTypes = [
    { id: 'ALL', name: 'All' },
    { id: 'MATCH_ODDS', name: 'MATCH ODDS' },
    { id: 'MATCH_ODDS_SB', name: 'MATCH ODDS SB' },
    { id: 'INNINGS_RUNS', name: 'INNINGS RUNS' },
    { id: 'TIED_MATCH', name: 'TIED MATCH' },
    { id: 'WIN', name: 'WIN' },
    { id: 'OVER_UNDER', name: 'OVER UNDER' },
  ]
  const defaultMarketType = 'ALL'
  const [marketType, setMarketType] = useState(defaultMarketType)
  const handleMarketTypeChange = (value) => {
    console.log('Market type: ', value)
    setMarketType(value)
  }

  /**
   * Currency filter section
   */
  const currencies = [
    { id: 'HKD', name: 'HKD' },
    { id: 'INR', name: 'INR' },
    { id: 'PKR', name: 'PKR' },
    { id: 'USD', name: 'USD' },
    { id: 'GBP', name: 'GBP' },
  ]
  const defaultCurrency = 'INR'
  const [currency, setCurrency] = useState(defaultCurrency)
  const handleCurrencyChange = (value) => {
    setCurrency(value)
  }

  /**
   * Data grid section
   */
  const [grandTotal, setGrandTotal] = useState({
    member: {
      turnover: '',
      win: '',
      comm: '',
      pnl: '',
    },
    agent: {
      win: '',
      comm: '',
      pnl: '',
    },
    uplineWin: '',
  })
  const [rows, setRows] = useState([])
  const signedValueSpan = (value) => {
    if (value < 0) {
      return (
        <span className="value-span value-span--value-negative">
          {parseFloat(value).toFixed(2)}
        </span>
      )
    } else {
      return (
        <span className="value-span value-span--value-positive">
          {parseFloat(value).toFixed(2)}
        </span>
      )
    }
  }
  const valueSpan = (value) => {
    return <span className="value-span">{parseFloat(value).toFixed(2)}</span>
  }

  const processRows = (rows) => {
    return rows.map((row) => {
      return {
        ...row,
        marketTotal: row.market.reduce(
          (acc, curr) => {
            acc.member.win += curr.member.win
            acc.member.comm += curr.member.comm
            acc.member.pnl += curr.member.pnl
            acc.member.turnover += curr.member.turnover

            acc.agent.win += curr.agent.win
            acc.agent.comm += curr.agent.comm
            acc.agent.pnl += curr.agent.pnl

            acc.uplineWin += curr.uplineWin

            return acc
          },
          {
            member: {
              win: 0,
              comm: 0,
              pnl: 0,
              turnover: 0,
            },
            agent: {
              win: 0,
              comm: 0,
              pnl: 0,
            },
            uplineWin: 0,
          }
        ),
      }
    })
  }
  const responses = useRef({})
  const fetchData = async (signal) => {
    try {
      setLoading(true)

      const query = `/api/reports/market-pnl?from=${fromDate.valueOf()}&to=${toDate.valueOf()}&sportId=${sportId}&marketType=${marketType}&whiteLabelSkinId=allSkins&providerId=-1&selectedPage=1&currency=${currency}`
      if (responses.current[query]) {
        const response = responses.current[query]
        console.log('from cache - ', response)
        if (response.data.result && response.data.result.grandTotal) {
          setGrandTotal(response.data.result.grandTotal)
        }
        if (response.data.result && response.data.result.rows) {
          const processedRows = processRows(response.data.result.rows)
          setRows(processedRows)
        }
        setLoading(false)
      } else {
        const response = await httpRequest(query, 'GET', undefined, signal)
        responses.current[query] = response
        console.log('from API - ', response)
        if (response.data.result && response.data.result.grandTotal) {
          setGrandTotal(response.data.result.grandTotal)
        }
        if (response.data.result && response.data.result.rows) {
          const processedRows = processRows(response.data.result.rows)
          setRows(processedRows)
        }
        setLoading(false)
      }
    } catch (error) {
      console.log(error)

      !signal.aborted && setLoading(false)
    }
  }

  useEffect(() => {
    const abortController = new AbortController()
    fetchData(abortController.signal)
    return () => {
      console.log('aborting')
      abortController.abort()
    }
  }, [])

  const handleFilterApplyClick = () => {
    const abortController = new AbortController()
    fetchData(abortController.signal)
  }

  const handleLogoutClick = () => {
    localStorage.removeItem('role')
    localStorage.removeItem('token')
    navigate('/login')
  }
  const buildCSV = () => {
    const csvString = rows
      .map((row) => {
        return `${moment(row.date).format('DD/MM/YYYY')}
      ${row.competitionName} - ${row.name}
      ${row.market
        .map((m) => {
          return `${m.name} - ${m.marketId},${m.member.turnover},${m.member.win},${m.member.comm},${m.member.pnl},${m.agent.win},${m.agent.comm},${m.agent.pnl},${m.uplineWin}\n`
        })
        .join('\n')}`
      })
      .join('\n')
    return `,T/O,Member Win,Member Comm,Member P&L,Agent Win,Agent Comm,Agent P&L,Upline
    ${csvString}`
  }

  return (
    <>
      <div className="page-container">
        <div className="header">
          <div className="header__title">
            <h2>P&L Report by Market</h2>
            <span>
              <RangePicker
                defaultValue={[fromDate, toDate]}
                format={dateFormat}
                showTime={{ format: 'HH:mm' }}
                size={'default'}
                onChange={handleDateRangeChange}
              />
            </span>
            <span>
              <CSVLink
                data={buildCSV()}
                filename={`pl-report-by-market-${new Date().getTime()}.csv`}
              >
                <Button type="primary">Download CSV</Button>
              </CSVLink>
            </span>
            <span className="header-span--pull-right">
              <span className="user-name">{userName}</span>
              <Button onClick={handleLogoutClick} type="primary" size="small">
                Logout <LogoutOutlined />
              </Button>
            </span>
          </div>
          <div className="header__filters">
            <span className="filter">
              <span className="filter-label">Sport: </span>
              <Select
                defaultValue={defaultSport}
                style={{ width: 180 }}
                onChange={handleSportChange}
              >
                {sports.map((s) => (
                  <Option value={s.id} key={s.id}>
                    {s.name}
                  </Option>
                ))}
              </Select>
            </span>
            <span className="filter">
              <span className="filter-label">Market Type: </span>
              <Select
                defaultValue={defaultMarketType}
                style={{ width: 180 }}
                onChange={handleMarketTypeChange}
              >
                {marketTypes.map((mt) => (
                  <Option value={mt.id} key={mt.id}>
                    {mt.name}
                  </Option>
                ))}
              </Select>
            </span>
            <span className="filter">
              <span className="filter-label">Currency: </span>
              <Select
                defaultValue={defaultCurrency}
                style={{ width: 180 }}
                onChange={handleCurrencyChange}
              >
                {currencies.map((cr) => (
                  <Option value={cr.id} key={cr.id}>
                    {cr.name}
                  </Option>
                ))}
              </Select>
            </span>
            <span className="filter">
              <Input
                placeholder="Event"
                // onChange={}
                style={{ width: 200 }}
              />
            </span>
            <span className="filter">
              <Input
                placeholder="Agency/Member Name"
                // onChange={}
                style={{ width: 200 }}
              />
            </span>
            <span className="filter">
              <Button
                type="primary"
                onClick={handleFilterApplyClick}
                loading={loading}
              >
                Apply
              </Button>
            </span>
            <span className="filter">
              <Button type="primary" danger>
                Clear
              </Button>
            </span>
          </div>
        </div>

        {!loading && (
          <div className="data-grid">
            <table>
              <colgroup>
                <col className="data-column" />
                <col span="4" className="data-column" />
                <col span="3" className="data-column" />
                <col />
              </colgroup>
              <thead>
                <tr>
                  <th></th>
                  <th colSpan="4">MEMBER</th>
                  <th colSpan="3">AGENT</th>
                  <th>UPLINE</th>
                </tr>
                <tr>
                  <th></th>
                  <th>T/O</th>
                  <th>Win</th>
                  <th>Comm</th>
                  <th>P&L</th>
                  <th>Win</th>
                  <th>Comm</th>
                  <th>P&L</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="row-data row-data--bold row-data--right">
                    Grand Total
                  </td>
                  <td>{valueSpan(grandTotal.member.turnover)}</td>
                  <td>{signedValueSpan(grandTotal.member.win)}</td>
                  <td>{signedValueSpan(grandTotal.member.comm)}</td>
                  <td>{signedValueSpan(grandTotal.member.pnl)}</td>
                  <td>{signedValueSpan(grandTotal.agent.win)}</td>
                  <td>{signedValueSpan(grandTotal.agent.comm)}</td>
                  <td>{signedValueSpan(grandTotal.agent.pnl)}</td>
                  <td>{signedValueSpan(grandTotal.uplineWin)}</td>
                </tr>
                {rows.map((row) => (
                  <>
                    <tr className="row-details row-date">
                      <td colSpan="9">
                        {moment(row.date).format('DD/MM/YYYY')}
                      </td>
                    </tr>
                    <tr className="row-details row-name">
                      <td colSpan="9">{`${row.competitionName} - ${row.name}`}</td>
                    </tr>
                    {row.market.map((m) => (
                      <tr className="row-data" key={`${m.name}-${m.marketId}`}>
                        <td className="row-data-name">
                          {`${m.name} - ${m.marketId}`}{' '}
                          <Link to={`/market-bets/${m.marketId}/${currency}`}>
                            <Tooltip title="View Bets">
                              <DollarCircleOutlined />
                            </Tooltip>
                          </Link>{' '}
                          <Link to={`/market-analysis/${m.marketId}`}>
                            <Tooltip title="View Analysis">
                              <SlidersOutlined />
                            </Tooltip>
                          </Link>{' '}
                          <Link to={`/spikes-analyzer/${m.marketId}`}>
                            <Tooltip title="View Spikes">
                              <RiseOutlined />
                            </Tooltip>
                          </Link>
                        </td>
                        <td className="row-data row-data--right ">
                          {valueSpan(m.member.turnover)}
                        </td>
                        <td className="row-data row-data--right ">
                          {signedValueSpan(m.member.win)}
                        </td>
                        <td className="row-data row-data--right ">
                          {signedValueSpan(m.member.comm)}
                        </td>
                        <td className="row-data row-data--right ">
                          {signedValueSpan(m.member.pnl)}
                        </td>
                        <td className="row-data row-data--right ">
                          {signedValueSpan(m.agent.win)}
                        </td>
                        <td className="row-data row-data--right ">
                          {signedValueSpan(m.agent.comm)}
                        </td>
                        <td className="row-data row-data--right ">
                          {signedValueSpan(m.agent.pnl)}
                        </td>
                        <td className="row-data row-data--right ">
                          {signedValueSpan(m.uplineWin)}
                        </td>
                      </tr>
                    ))}

                    <tr>
                      <td className="row-data row-data--bold row-data--right">
                        Total
                      </td>
                      <td className="row-data row-data--right ">
                        {valueSpan(row.marketTotal.member.turnover)}
                      </td>
                      <td className="row-data row-data--right ">
                        {signedValueSpan(row.marketTotal.member.win)}
                      </td>
                      <td className="row-data row-data--right ">
                        {signedValueSpan(row.marketTotal.member.comm)}
                      </td>
                      <td className="row-data row-data--right ">
                        {signedValueSpan(row.marketTotal.member.pnl)}
                      </td>
                      <td className="row-data row-data--right ">
                        {signedValueSpan(row.marketTotal.agent.win)}
                      </td>
                      <td className="row-data row-data--right ">
                        {signedValueSpan(row.marketTotal.agent.comm)}
                      </td>
                      <td className="row-data row-data--right ">
                        {signedValueSpan(row.marketTotal.agent.pnl)}
                      </td>
                      <td className="row-data row-data--right ">
                        {signedValueSpan(row.marketTotal.uplineWin)}
                      </td>
                    </tr>
                  </>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {loading && <LoadingSpinner />}
      </div>
    </>
  )
}

export default PLReportByMarket
